import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Profile from "./Profile";
import "./App.css";

function App() {

  const handleGoogleLogin = () => {
    window.location.href = "https://google-oauth-spa.onrender.com/auth/google";
  };

  return (
    <BrowserRouter>
      <Routes>

        <Route
          path="/"
          element={
            <div className="card">
              <h2 className="title">🔐 Google OAuth Login</h2>
              <p>Please sign in using your Google Account</p>

              <button className="btn" onClick={handleGoogleLogin}>
                Sign in with Google
              </button>
            </div>
          }
        />

        <Route path="/profile" element={<Profile />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;